export default function FooterSection() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/b4340cdd1673521bdb15ca49ead9cb84/fa617871f52148f2c372440aa483fbed.png" 
              alt="GLOBAL ENERGY SRL Logo" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-gray-400 leading-relaxed mb-4">
              Leader nel <strong>risparmio energetico</strong> ad Arezzo. Oltre 10 anni di esperienza in <strong>pannelli fotovoltaici</strong> e <strong>energie rinnovabili</strong>.
            </p>
            <p className="text-xs text-gray-500">P.IVA: IT-02198440519</p>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4">Link Rapidi</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-sm text-gray-400 hover:text-emerald-500 transition-colors cursor-pointer">
                  Chi Siamo
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-gray-400 hover:text-emerald-500 transition-colors cursor-pointer">
                  Servizi
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('sectors')} className="text-sm text-gray-400 hover:text-emerald-500 transition-colors cursor-pointer">
                  Settori
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('why-us')} className="text-sm text-gray-400 hover:text-emerald-500 transition-colors cursor-pointer">
                  Perché Sceglierci
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-sm text-gray-400 hover:text-emerald-500 transition-colors cursor-pointer">
                  Contatti
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4">Servizi</h4>
            <ul className="space-y-2">
              <li className="text-sm text-gray-400">Risparmio Energetico</li>
              <li className="text-sm text-gray-400">Pannelli Fotovoltaici</li>
              <li className="text-sm text-gray-400">Energie Rinnovabili</li>
              <li className="text-sm text-gray-400">Strutture in Ferro</li>
              <li className="text-sm text-gray-400">Forniture Industriali</li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4">Contatti</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-emerald-500 mt-1"></i>
                <span className="text-sm text-gray-400">Via Don Luigi Sturzo 181<br />52100 Arezzo (AR)</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-emerald-500 mt-1"></i>
                <a href="mailto:info.globalenergysrl@gmail.com" className="text-sm text-gray-400 hover:text-emerald-500 cursor-pointer">
                  info.globalenergysrl@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © 2025 GLOBAL ENERGY SRL. Tutti i diritti riservati.
            </p>
            <div className="flex items-center gap-6">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-emerald-500 transition-colors cursor-pointer">
                Website Builder
              </a>
              <a href="#" className="text-sm text-gray-400 hover:text-emerald-500 transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-gray-400 hover:text-emerald-500 transition-colors cursor-pointer">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
